import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/turn-circle.svg'
import _imports_1 from '@/assets/icons/chevron-down-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-5817f586"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bus-stop-row-wapper" }
const _hoisted_2 = { class: "bus-route" }
const _hoisted_3 = {
  key: 0,
  class: "turn-icon",
  src: _imports_0,
  alt: "버스 회차 지점"
}
const _hoisted_4 = {
  key: 1,
  class: "chevron-down",
  src: _imports_1,
  alt: "정류장"
}
const _hoisted_5 = { class: "bus-stop-infos" }
const _hoisted_6 = { class: "bus-stop-name" }
const _hoisted_7 = { class: "bus-stop-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["bus-route--top", { disabled: $props.busStop.isFirstStop || $props.isInsideShuttle }])
      }, null, 2 /* CLASS */),
      ($props.busStop.isReturnStop)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (_openBlock(), _createElementBlock("img", _hoisted_4)),
      _createElementVNode("div", {
        class: _normalizeClass(["bus-route--bottom", { disabled: $props.isLastRow }])
      }, null, 2 /* CLASS */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString($props.busStop.name), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_7, _toDisplayString($setup.arrivalTimeText), 1 /* TEXT */)
    ])
  ]))
}